module.exports = __webpack_public_path__ + "static/img/3@2x.d5dd9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/3@2x.png
// module id = DuQb
// module chunks = 8